import React from 'react';
import PropTypes from 'prop-types';

import { InstantSearch, Configure } from 'react-instantsearch-dom';
import searchClient from '../../utils/algolia';
import { createProductSlugFilter } from './utils/moduleProducts';

const CMSModuleProducts = ({ products, children }) => {
  /*
     This component wraps the product rendering logic for CMS modules that contain products.
    It creates the appropriate architecture to allow for the module tissue itself to connect via
    connectStateResults to render the products we filter by in this component.
  */

  const { filter, filteredProductLength } = createProductSlugFilter(products);

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX}
    >
      <Configure
        hitsPerPage={filteredProductLength}
        filters={filter}
      />
      {children}
    </InstantSearch>
  );
};

CMSModuleProducts.propTypes = {
  products: PropTypes.array.isRequired,
  children: PropTypes.any.isRequired
};

export default CMSModuleProducts;
